import { render, staticRenderFns } from "./Hitungstok.vue?vue&type=template&id=56d96d97&"
import script from "./Hitungstok.vue?vue&type=script&lang=js&"
export * from "./Hitungstok.vue?vue&type=script&lang=js&"
import style0 from "./Hitungstok.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports